import { Field } from "react-final-form";
import { StyledLabel } from "../StepOne";

const ReadOnlyField = ({ label, fieldName }) => {
	return (
		<>
			<StyledLabel>{label}</StyledLabel>
			<p className='text-muted' style={{ fontSize: "12px" }}>
				<Field name={fieldName} subscription={{ value: true }}>
					{({ input: { value } }) => {
						return <>{value}</>;
					}}
				</Field>
			</p>
		</>
	);
};

export default ReadOnlyField;
